import {
  FilterCategoryModel,
  FilterItemModel,
} from "@/models/filterItem.model";
import { KioskModel } from "@/models/kiosk.model";
import { AmenityModel } from "proximiio-js-library/lib/models/amenity";
import Feature from "proximiio-js-library/lib/models/feature";
import Entertainment from "@/assets/entertainment.svg";
import iFly from "@/assets/ifly.svg";
import LittleExplorers from "@/assets/little-explorers.svg";
import MagicPlanet from "@/assets/magic-planet.svg";
import Snow from "@/assets/snow.svg";
import VoxCinema from "@/assets/vox-cinema.svg";

// import thrillRides from '@/assets/Thrill-rides.svg';
import junorRides from "@/assets/Junior-rides.svg";
// import tirNaNog from '@/assets/Tir-na-nOg.svg';
import playgrounds from "@/assets/Playgrounds.svg";
import zoo from "@/assets/Zoo.svg";
import restaurants from "@/assets/Restaurants.svg";
import onTheGo from "@/assets/On-the-Go.svg";
import icecream from "@/assets/ice-cream.svg";
import shops from "@/assets/shops.svg";
import camera from "@/assets/camera.svg";
import toilets from "@/assets/toilets.svg";
import accessibleChanging from "@/assets/accessible-changing.svg";
import nursing from "@/assets/nursing.svg";
import babyChanging from "@/assets/baby-changing.svg";
import firstAid from "@/assets/first-aid.svg";
import admissions from "@/assets/open-or-closed.svg";
import exit from "@/assets/exit.svg";
import members from "@/assets/members.svg";
import parking from "@/assets/parking.svg";
import lockers from "@/assets/lockers.svg";
import aed from "@/assets/aed.svg";
import smoking from "@/assets/smoking.svg";
import atm from "@/assets/atm.svg";
import freestyle from "@/assets/freestyle.png";
import closed from "@/assets/closed.svg";
import queueTime from "@/assets/queue-time.svg";
import showEntertainment from "@/assets/shows-entertainment-icon.webp";
import zooExperiences from "@/assets/zoo-experiences-icon.webp";
// import jingleFest from "@/assets/jingle-fest.svg";
import { FaRegClock } from "react-icons/fa6";
import { TbBuildingCarousel } from "react-icons/tb";
import { LiaRestroomSolid } from "react-icons/lia";

export const getListAsClosest = () => {
  const closestList = [];
  for (const category of filterCategories) {
    closestList.push(category.items.filter((item) => item.listAsClosest));
  }
  return closestList.flat(2);
};

export const getHiddenItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter((item) => item.hideMapIcon)) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getExcludedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.excludeFromSearch,
    )) {
      list.push(item.id);
    }
  }
  return list.flat(2);
};

export const getHiddenUntilSelectedItems = () => {
  const list = [];
  for (const category of filterCategories) {
    for (const item of category.items.filter(
      (item) => item.hideIconUntilSelected,
    )) {
      list.push(item.id);
    }
  }
  return list.flat();
};

export const filterCategories: FilterCategoryModel[] = [
  {
    title: "attractions",
    id: "amenities",
    color: "192,98%,16%",
    icon: TbBuildingCarousel,
    items: [
      /*{
				title: 'thrill-rides',
				iconImage: thrillRides,
				id: '2ceebcfb-0db3-483b-8798-0f8e720167e8:5d4de5ec-7dc9-4bc5-9e48-c966fe39f9ab',
				type: 'list',
				background: 'rgb(0 114 218 / var(--tw-bg-opacity))',
			},*/
      {
        title: "junior-rides",
        iconImage: junorRides,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:d6597c1e-2ee4-4dbf-a4db-31c9bb9dd1b3",
        type: "list",
        color: "rgb(242 206 0 / 1)",
      },
      /*{
				title: 'tir-na-nog',
				iconImage: tirNaNog,
				id: '2ceebcfb-0db3-483b-8798-0f8e720167e8:db08735f-4c53-449a-9ab9-eebe23165b57',
				type: 'list',
				background: 'RGB(0 62 119 / var(--tw-bg-opacity))',
			},*/
      {
        title: "playgrounds",
        iconImage: playgrounds,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:887bc7b3-dbcf-4dca-a958-0def71e18c97",
        type: "list",
        color: "RGB(58 220 201 / var(--tw-bg-opacity))",
      },
      {
        title: "zoo",
        iconImage: zoo,
        id: [
          "2ceebcfb-0db3-483b-8798-0f8e720167e8:1f0ab7cc-dd8d-48c5-996f-80a0a29bdb3b",
          "2ceebcfb-0db3-483b-8798-0f8e720167e8:8db5f42c-9ce9-43f8-935e-1cae21931b11",
        ],
        type: "list",
        color: "RGB(152 216 1 / var(--tw-bg-opacity))",
      },
      {
        title: "show-entertainment",
        iconImage: showEntertainment,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:d09ad36e-cbf7-407e-a2f8-bf38836b5360",
        type: "list",
        color: "RGB(58 220 201 / var(--tw-bg-opacity))",
      },
      {
        title: "zoo-experiences",
        iconImage: zooExperiences,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:8db5f42c-9ce9-43f8-935e-1cae21931b11",
        type: "list",
        color: "RGB(0 152 99 / var(--tw-bg-opacity))",
      },
      {
        title: "food-drink",
        iconImage: restaurants,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:909b0368-578d-4d3b-ad6e-616fd5ca303a",
        type: "list",
        color: "RGB(238 139 50 / var(--tw-bg-opacity))",
      },
      {
        title: "on-the-go",
        iconImage: onTheGo,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:16c32b4a-34c3-42fa-abdf-031bd7daf6ca",
        type: "list",
        color: "RGB(242 206 0 / var(--tw-bg-opacity))",
      },
      {
        title: "icecream",
        iconImage: icecream,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:75a6c0d4-8798-4608-9b23-7a088b861036",
        type: "list",
        color: "RGB(204 91 155 / var(--tw-bg-opacity))",
      },
      {
        title: "shops-only",
        iconImage: shops,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:f5c0d482-81fc-4db9-92a6-b6c95ff0e567",
        type: "list",
        color: "RGB(255 143 41 / var(--tw-bg-opacity))",
      },
      {
        title: "ride-photography-hut",
        iconImage: camera,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:22a90580-7ce1-476e-93fb-76c80cbe97c9",
        type: "list",
        color: "RGB(228 0 50 / var(--tw-bg-opacity))",
      },
      /*{
        title: "jingle-fest",
        iconImage: jingleFest,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:97fe64fd-a2be-4c02-86ab-9d0ec0459b79",
        type: "list",
        color: "RGB(12 60 45 / var(--tw-bg-opacity))",
      },*/
    ],
  },
  {
    title: "facilities",
    id: "facilities",
    color: "192,98%,16%",
    icon: LiaRestroomSolid,
    items: [
      {
        title: "toilets",
        iconImage: toilets,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:8ae72074-3fb5-400a-94cd-2e2a6361a030",
        type: "list",
        color: "RGB(0 59 74 / var(--tw-bg-opacity))",
      },
      {
        title: "accessible-changing",
        iconImage: accessibleChanging,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:cef9ff5c-3c1c-4c1d-bbc8-b566253cbcbe",
        type: "list",
        color: "RGB(0 59 74 / var(--tw-bg-opacity))",
      },
      {
        title: "nursing-room",
        iconImage: nursing,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:2b218676-5e9b-4585-a4d0-bfbc6a62a657",
        type: "list",
        color: "RGB(0 59 74 / var(--tw-bg-opacity))",
      },
      {
        title: "baby-changing",
        iconImage: babyChanging,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:70714fb4-d2f1-4cd5-a793-42cec78d74c0",
        type: "list",
        color: "RGB(0 59 74 / var(--tw-bg-opacity))",
      },
      {
        title: "first-aid",
        iconImage: firstAid,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:1bf5daf9-469c-426e-b032-51c600c4c5d4",
        type: "list",
        color: "RGB(140 193 15 / var(--tw-bg-opacity))",
      },
      {
        title: "admissions",
        iconImage: admissions,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:1de6ce4e-3eda-4a1e-9b56-361b44b8294e",
        type: "list",
        color: "RGB(0 152 99 / var(--tw-bg-opacity))",
      },
      {
        title: "exit",
        iconImage: exit,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:ddd71ba4-8808-484a-8125-ca84d2948fcc",
        type: "list",
        color: "RGB(0 152 99 / var(--tw-bg-opacity))",
      },
      {
        title: "membership-hut",
        iconImage: members,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:a8df80a8-8323-4c3f-831e-cf04de731ada",
        type: "list",
        color: "RGB(0 152 99 / var(--tw-bg-opacity))",
      },
      {
        title: "parking",
        iconImage: parking,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:9594f406-0bb6-4a8a-b75b-61ac8558a053",
        type: "list",
        color: "RGB(0 114 218 / var(--tw-bg-opacity))",
      },
      {
        title: "lockers",
        iconImage: lockers,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:8111bf7b-8b2b-4f47-aa09-055c40b76635",
        type: "list",
        color: "RGB(0 114 218 / var(--tw-bg-opacity))",
      },
      {
        title: "aed",
        iconImage: aed,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:f8a5ef7d-94b8-4a4c-8e9f-d8c8c221a4e4",
        type: "list",
        color: "RGB(140 193 15 / var(--tw-bg-opacity))",
      },
      {
        title: "smoking-vaping",
        iconImage: smoking,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:b018b4ec-cf12-4de9-8d23-cbab29fe5ed8",
        type: "list",
        color: "RGB(0 114 218 / var(--tw-bg-opacity))",
      },
      {
        title: "atm",
        iconImage: atm,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:176bacd7-6b66-41b8-85eb-af0401593a4f",
        type: "list",
        color: "RGB(0 152 99 / var(--tw-bg-opacity))",
      },
      {
        title: "freestyle-cup-station",
        iconImage: freestyle,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:c9bb7ec9-b3e5-4962-861d-3e4eebe4734c",
        type: "list",
        color: "RGB(228 33 43 / var(--tw-bg-opacity))",
      },
      {
        title: "closed-areas",
        iconImage: closed,
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:3f19cf0e-c9d8-4f40-a21a-4cee88ff6676",
        type: "list",
        color: "RGB(228 0 50 / var(--tw-bg-opacity))",
      },
    ],
  },
  {
    title: "live-queue-times",
    id: "live-queue-times",
    color: "192,98%,16%",
    icon: FaRegClock,
    items: [
      {
        title: "< 5 min",
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:3a3f11ba-c3b1-4675-a1ae-6ac949cfb573",
        type: "list",
        color: "RGB(152 216 1 / var(--tw-bg-opacity))",
        iconImage: queueTime,
      },
      {
        title: "5 - 15 min",
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:39370efe-eeab-4c4a-8570-feb957669c3d",
        type: "list",
        color: "RGB(0 152 99 / var(--tw-bg-opacity))",
        iconImage: queueTime,
      },
      {
        title: "15 - 30 min",
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:f2d602f8-9e94-4ef4-a901-067879892520",
        type: "list",
        color: "RGB(255 143 41 / var(--tw-bg-opacity))",
        iconImage: queueTime,
      },
      {
        title: "+30 min",
        id: "2ceebcfb-0db3-483b-8798-0f8e720167e8:9095d4bc-7f79-43f6-ad42-d9a2a4cc44e6",
        type: "list",
        color: "RGB(228 0 50 / var(--tw-bg-opacity))",
        iconImage: queueTime,
      },
    ],
  },
];

filterCategories.push({
  title: "hidden",
  id: "hidden",
  listed: false,
  items: [
    {
      title: "hidden",
      id: getHiddenUntilSelectedItems() as string[],
      type: "list",
      listed: false,
    },
  ],
});

export const kiosks: KioskModel[] = [
  {
    name: "kiosk",
    latitude: 25.21620020891565,
    longitude: 55.40792571152656,
    level: 0,
    pitch: 40,
    bearing: 10,
    zoom: 18,
    poiId:
      "75698d35-0918-4a2b-a8ab-77b93a618e61:c2f3d327-d2ee-4d6f-a14f-2a85dfb1ab8d",
  },
];

export const excludedAmenities: string[] = getExcludedItems() as string[];

// Function to build additional filters based on amenities and features
export const buildAdditionalFilters = ({
  amenities,
  features,
  language,
}: {
  amenities: AmenityModel[] | null;
  features: Feature[] | null;
  language: string;
}): FilterItemModel[] | void => {
  // Early exit if amenities or features are missing
  if (!amenities) {
    console.error("amenities is null");
    return;
  }

  if (!features) {
    console.error("features is null");
    return;
  }

  // Define amenity titles and their mapping to ids/features
  const amenityMapping: {
    [key: string]: {
      amenity?: AmenityModel;
      features: Feature[];
      icon: string;
    };
  } = {
    "Snow/Ski": { amenity: undefined, features: [], icon: Snow },
    "Vox Cinema": { amenity: undefined, features: [], icon: VoxCinema },
    "Magic Planet": { amenity: undefined, features: [], icon: MagicPlanet },
    iFLY: { amenity: undefined, features: [], icon: iFly },
    "Little Explorers": {
      amenity: undefined,
      features: [],
      icon: LittleExplorers,
    },
    Entertainment: { amenity: undefined, features: [], icon: Entertainment },
  };

  // Map amenities to their respective amenity titles
  for (const amenity of amenities) {
    if (amenityMapping[amenity.title]) {
      amenityMapping[amenity.title].amenity = amenity;
    }
  }

  // Map features to their respective amenities
  for (const feature of features) {
    for (const key in amenityMapping) {
      const { amenity } = amenityMapping[key];
      if (feature.properties?.amenity === amenity?.id) {
        amenityMapping[key].features.push(feature);
      }
    }
  }

  // Utility function to retrieve a translated title
  const getTranslatedTitle = (feature: Feature): string => {
    const { title_i18n, title } = feature.properties || {};
    return title_i18n?.[language] || title_i18n?.en || title;
  };

  const items: FilterItemModel[] = [];

  // Create filter items for each amenity based on available features
  for (const key in amenityMapping) {
    const { amenity, features, icon } = amenityMapping[key];

    if (amenity && features.length > 0) {
      let itemTitle: string | undefined;

      // If there is only one feature, use the feature title
      if (features.length === 1) {
        itemTitle = getTranslatedTitle(features[0]);
      }

      // Set up the item object for the filter list
      const baseItem: FilterItemModel = {
        title: key.toLowerCase().replace(/\s/g, "-"), // Convert title to kebab-case
        translatedTitle: itemTitle,
        iconImage: icon,
        id: [amenity.id],
        hideMapIcon: true,
        type: "list",
      };

      // Push items to the list based on the type (list or single)
      if (key === "Entertainment") {
        // For "Entertainment", push individual features
        features.forEach((feature) => {
          items.push({
            ...baseItem,
            type: "single",
            title: getTranslatedTitle(feature)
              .toLowerCase()
              .replace(/\s/g, "-"), // Convert title to kebab-case
            translatedTitle: getTranslatedTitle(feature),
            featureId: feature.id,
          });
        });
      } else {
        // For other amenities, push as a list
        items.push(baseItem);
      }
    }
  }

  const entertainmentIndex = filterCategories.findIndex(
    (category) => category.id === "entertainment",
  );
  filterCategories[entertainmentIndex].items = items;
};
